import { Injectable } from '@angular/core';
import { ApiRoutes } from "../../../services/apiroutes";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { ILeadSubmitModel, LeadSubmitModel } from "./lead-submit.model";
import { map } from "rxjs/operators";
import { AuthService } from "../../../services/auth.service";
import { ILeadRequestModel, LeadRequestModel } from './lead-request.model';
import { IRegisterModel } from '../../authentication/register/register.model';

@Injectable({
    providedIn: 'root'
})
export class LeadSubmitService {

    lead: LeadSubmitModel;

    constructor(private http: HttpClient, private auth: AuthService) {
    }

    getLeadById(lead_id) {
        const url = `${ApiRoutes.LeadRequest}leads/${lead_id}/`;
        return this.http.get<LeadRequestModel>(url);
    }

    postLead(leadRequest) {
        const url = `${ApiRoutes.LeadRequest}leads/`;
        return this.http.post<LeadRequestModel>(url, leadRequest, { observe: 'response' });
    }

    putLead(lead_id, leadRequest) {
        const url = `${ApiRoutes.LeadRequest}leads/${lead_id}/`;
        return this.http.put<ILeadRequestModel>(url, leadRequest);
    }

    saveLeadRequest(lead_id) {
        this.lead = new LeadSubmitModel(lead_id);

        const url = `${ApiRoutes.LeadRequest}web-request/lead_request_create/`;
        return this.http.post<ILeadSubmitModel>(url, this.lead.getSavePayload()).pipe(
            map((data: ILeadSubmitModel) => {
                this.lead.savePayloadToModel(data);
            })
        );
    }

}
